<template>
  <v-card flat class="mt-0">
    <v-card-text class="mt-0">
      <!-- <v-card>{{filterUser (identifiants).length}}</v-card> -->
      <v-text-field
        placeholder="Rechercher"
        v-model="search"
        append-icon="mdi-magnify"
        @keyup="filterUser()"
      ></v-text-field>

      <v-list>
        <v-list-item
          v-for="(item, index) in filterUser(identifiants)"
          :key="index"
          class="project"
          v-bind:class="{
            warning: !item.districts && item.role === 'superviseur',
          }"
        >
          <v-list-item-content>
            <v-list-item-title v-html="item.displayName"></v-list-item-title>
            <v-list-item-title v-html="item.email"></v-list-item-title>
            <v-list-item-subtitle v-html="item.role"></v-list-item-subtitle>
            <v-list-item-subtitle v-if="item.isPaysanRelais"
              >Paysan Relais</v-list-item-subtitle
            >

            <v-list-item-subtitle v-if="item.dateLastConnexion"
              >Date de dernière connexion</v-list-item-subtitle
            >
            <v-list-item-subtitle
              v-if="item.dateLastConnexion"
              v-html="
                $moment(item.dateLastConnexion).format('DD-MM-YYYY HH:mm:ss')
              "
            ></v-list-item-subtitle>
            <v-list-item-subtitle v-if="item.projetSelected">
              Projet actif dans l'application :
              {{ item.projetSelected.ll_programme }}
            </v-list-item-subtitle>

            <v-list-item-subtitle>
              <v-chip
                color="lime"
                dark
                v-for="(region, index) in item.regionsSupervisees"
                :key="index"
                class="ma-2"
              >
                {{ region.ll_region }}
              </v-chip>
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              <v-chip
                color="purple"
                dark
                v-for="(region, index) in item.districts"
                :key="index"
                class="ma-2"
              >
                {{ region.ll_district }}
              </v-chip>
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              <v-chip
                color="secondary"
                dark
                v-for="(projet, index) in item.projets"
                :key="index"
                class="ma-2"
              >
                {{ projet.ll_programme }} - {{ projet.abbr_bailleur }}
              </v-chip>
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-icon v-if="item.isAnimateur">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :class="item.isPaysanRelais ? 'secondary' : 'info'"
                  outlined
                  fab
                  dark
                  v-on="on"
                  @click="setIsPaysanRelais(item)"
                >
                  <v-icon>mdi-account-supervisor-circle</v-icon>
                </v-btn>
              </template>
              <span>Paysan Relais</span>
            </v-tooltip>
          </v-list-item-icon>
          <v-list-item-icon>
            <v-btn color="primary" fab dark @click="detailsUser(item)">
              <v-icon>chevron_right</v-icon>
            </v-btn>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  created() {},
  components: {
    DialogProjetsDeUser: require("@/components/DialogProjetsDeUser.vue")
      .default,
    DialogLocalisationDeUser: require("@/components/DialogLocalisationDeUser.vue")
      .default,
    DialogRegionsSupervisees: require("@/components/DialogRegionsSupervisees.vue")
      .default,
  },
  data() {
    return {
      search: "",
    };
  },
  props: {
    identifiants: {
      type: Array,
      required: true,
    },
  },
  methods: {
    setIsPaysanRelais(superviseur) {
      //console.log(superviseur);
      var ref = this.$firebase
        .firestore()
        .collection("users")
        .doc(superviseur.uid);
      var isPaysanRelais = true;
      if (superviseur.isPaysanRelais) {
        isPaysanRelais = false;
      } else {
        isPaysanRelais = true;
      }
      console.log("setIsPaysanRelais : ", isPaysanRelais);
      ref.set(
        {
          isPaysanRelais: isPaysanRelais,
        },
        { merge: true }
      );
    },

    setIsAnimateur(superviseur) {
      console.log(superviseur);
      var cityRef = this.$firebase
        .firestore()
        .collection("users")
        .doc(superviseur);

      var setWithMerge = cityRef.set(
        {
          isAnimateur: false,
        },
        { merge: true }
      );
    },
    goToGroupesDeSuperviseurs(superviseur) {
      //console.log(superviseur);
      this.$router.push({
        name: "groupes-listeGroupes-id",
        params: { superviseur },
      });
    },
    detailsUser(item) {
      console.log(item);
      this.$router.push({
        name: "Users-id",
        params: { item },
      });
    },
    filterUser(identifiants) {
      let self = this;
      const emailFiltres = _.filter(identifiants, function (item) {
        return (
          item.email.indexOf(self.search) > -1 ||
          item.email.indexOf(_.toUpper(self.search)) > -1 ||
          item.email.indexOf(_.toLower(self.search)) > -1
        );
      });
      const displayNameFiltres = _.filter(identifiants, function (item) {
        return (
          item.displayName.indexOf(self.search) > -1 ||
          item.displayName.indexOf(_.toUpper(self.search)) > -1 ||
          item.email.indexOf(_.toLower(self.search)) > -1
        );
      });
      //console.log(this.search);
      //displayName
      //email

      return _.union(emailFiltres, displayNameFiltres);
    },
    ...mapActions({
      getRegionsdeSuperviseurOnce: "Regions/getRegionsdeSuperviseurOnce",
    }),
  },
};
</script>

<style lang="scss" scoped></style>
